import {AppHelper} from "../../appHelper";
import {HTTPService, JsonResultClass} from "../../core/util/httpManager";
import {NotificationHelper} from "../../core/util/notificationHelper";
import {Config} from "../../core/config/config";
import {AppBaseProps, CommonApp, Context, Entity} from "../../core/components/commonApp";
import {MetaDataHelper} from "../../core/util/metaDataHelper";
import {Helper} from "../../core/util/helper";
import {Grid} from "../../core/components/grid";
import {GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType} from "../../core/components/toolBar";
import {DialogHelper} from "../../core/util/dialogHelper";
import {General} from "../../../siteManagement/general";
import {Sheet, SheetEventType} from "../../../siteManagement/sheet";
import RecurringTaskHistoryApp, {RecurringTaskHistoryProps} from "./recurringTaskHistory";
import {Commands} from "../../core/util/commandManager";
import {RecurenceSchemaEntity} from "./recurrenceSchema";
import ChangeTaskPeriodApp, {ChangePeriodEntity, ChangeTaskPeriodAppProps} from "./changeTaskPeriod";
import ExecuteAllAppLauncher, {ExecuteAllAppLauncherProps} from "./executeAllTasks";
import {WorkPackageGrid, WorkPackageGridProps} from "./workPackageGrid";
import {WorkPackageEntity} from "../workPackage/workPackage";
import TriggeringErrorListApp, {TriggeringErrorListAppProps, TriggeringErrorListEntity} from "./triggeringErrorList";
import {EditTaskMachineApp, EditTaskMachineAppProps} from "./editTaskMachine";
import {openCancellationView, TaskPositionCancellingParam} from "../taskCancellingPreview";
import { PageTitleProps } from "../../core/components/pageTitle";
import { EnumEntity, KeyValuePair } from "../../commonInterfaces";
import React from "react";

export default class RecurringTaskApp extends React.Component<RecurringTaskAppProps, RecurringTaskAppState> {
    common = new AppHelper();
    workPackageGridOptions: {};
    machineGridOptions: {};
    workPackagesDs :KeyValuePair<string,string>[] = [];
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    deleteEnabled: boolean = false;
    isDeleted: boolean;
    toleranceStartEnabled: boolean = true;
    toleranceEndEnabled: boolean = true;
    private lockId: number;
    sheet: Sheet;
    mashinesGridRef = null;

    constructor(props: RecurringTaskAppProps) {
        super(props);
        this.common.init(this);
        this.toleranceStartEnabled = Helper.hasValue(props.entity.ToleranceStart);
        this.toleranceEndEnabled = Helper.hasValue(props.entity.ToleranceEnd);
        this.reloadWorkPackages(props.entity.WorkPackages);
        if (this.props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(this.releaseLock);
        }
        this.state = { 
            deleteMachineEnabled: false,
            applyTemplateEnabled: false,
            enableMachineDeactivate: false 
        };
        this._refreshDeleteEnabled();

        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.sheet.bind(SheetEventType.Custom, (data: any) => {
            if (Helper.hasValue(data) && data.command === "reset") {
                this.handleFieldChange({model: data.field}, null);
            }
            if (Helper.hasValue(data) && data.command === "render") {
                this.setState({});
            }
        });
    }

    private _refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew 
            && this.props.entity.RecordRight.CanWrite 
            && (this.props.entity.MergedProps.State.Value === TaskState.Draft ||
                Config.user.isSysAdmin);
    }

    remove = async () => {
        let isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            let result = await HTTPService.post("RecurringTask/Delete", { id: this.props.entity.Id, lockId: this.props.entity.IsId });
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.Task.Msg.Deleted"));
                this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                if (General.Sheet.Manager.getSheetsCount() > 1) {
                    this.common.sheetWrapper.hide();
                } else {
                    this.deleteEnabled = false;
                    this.isDeleted = true;
                    this.props.entity.RecordRight.CanWrite = false;
                    this.setState({});
                    setTimeout(() => {
                        window.location.href = Config.baseUrl + "DynamicSearch/TaskGroup";
                    }, 1000);
                }
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }
    releaseLock = () => {
        if (this.lockId != undefined) {
            clearInterval(this.lockId);
            Helper.releaseLock(this.props.entity.IsId, "FST_RECURRING_TASKS");
            this.lockId = undefined;
        }
    }

    save = async () => {
        let isOk = await this.onSave();
        if(!isOk) return;

        NotificationHelper.showSuccessMessage(Config.translations.savingSuccessfulMessage);

        if (!this.props.context.standAlone) {
            this.common.sheetWrapper.hide();
        }
    }

    matchMergedProp = (fieldName: string): string => {
        let match = fieldName.match(/^entity\.(?:MergedProps|ExplicitProps)\.(\w+)$/);
        if (Helper.hasValue(match))
            return match[1];
        else
            return null;
    }

    updateProp = (prop: string, value: any) => {
        this.common.handleFieldChange({model: 'entity.ExplicitProps.' + prop}, value);
        let parentValue = MetaDataHelper.getFieldValue(this.props.entity, 'entity.ParentProps.' + prop);
        let mergedValue = value;
        if (Helper.isNullOrEmpty(value) && Helper.hasValue(parentValue))
            mergedValue = parentValue;
        this.common.handleFieldChange({model: 'entity.MergedProps.' + prop}, mergedValue, null,
            () => {this.common.validate()});
    }

    private handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        let prop = this.matchMergedProp(field.model);
        if (Helper.hasValue(prop)) {
            this.updateProp(prop, value);
        } else {
            switch (field.model) {
                case "toleranceStartEnabled":
                    this.toleranceStartEnabled = value;
                    if (!value) {
                        const copyEntity: RecurringTaskEntity = JSON.parse(JSON.stringify(this.props.entity));
                        copyEntity.ToleranceStart = null;
                        Helper.updateEntity(this.props.entity, copyEntity);
                    }
                    break;
                case "toleranceEndEnabled":
                    this.toleranceEndEnabled = value;
                    if (!value) {
                        const copyEntity: RecurringTaskEntity = JSON.parse(JSON.stringify(this.props.entity));
                        copyEntity.ToleranceEnd = null;
                        Helper.updateEntity(this.props.entity, copyEntity);
                    }
                    break;
            }
            if (!isInit)
                this.common.handleFieldChange(field, value, dataItem);
        }
    }
    private onSave = (): Promise<boolean> =>{
        return new Promise<boolean>(async resolve => {
            if (!this.props.entity.RecordRight.CanWrite)
                resolve(true);
            else if (this.common.validate()) {
                let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/Save", {
                    model: {...this.props.entity, Machines: [], WorkPackages: []},
                    lockId: this.props.entity.IsId
                });
                if (result.Code === 0) {
                    if (this.props.entity.IsNew)
                        General.Functions.HistoryState.replaceState("RecurringTask/Edit?id=" + encodeURIComponent(result.Data.Id));
                    let taskEntity = result.Data;
                    this.updateEntity(taskEntity);
                    resolve(true)
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                    this.common.handlePostSave(false);
                    resolve(false);
                }
            }
        })
    }
    
    // noinspection JSUnusedGlobalSymbols
    createWorkpackageGrid = ()=>{
        if(Helper.hasValue(this.props.context.workPackageGridOptions)){
            const props:WorkPackageGridProps ={
                entity: this.props.entity,
                gridOptions: this.props.context.workPackageGridOptions,
                // lockControl: this.props.context.lockControl,
                doUpdate: (packages)=> {
                    this.reloadWorkPackages(packages);
                    this.common.handleFieldChange({model: "entity.WorkPackages"}, packages);
                    //this.internalSave();
                },
                doSave: this.onSave
            }
            return (<>
               <WorkPackageGrid {...props}/>
            </>)
        }
        return null
    }
    
    private internalSave = async (action:() => void = () => {}) => {
        if (!this.props.entity.RecordRight.CanWrite)
            action();
        else if (this.common.validate()) {
            let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/Save", { model: {...this.props.entity, Machines: [], WorkPackages: []}, lockId: this.props.entity.IsId });
            if (result.Code === 0) {
                if (this.props.entity.IsNew)
                    General.Functions.HistoryState.replaceState("RecurringTask/Edit?id=" + encodeURIComponent(result.Data.Id));
                let taskEntity = result.Data;
                this.updateEntity(taskEntity);
                action();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
                this.common.handlePostSave(false);
            }
        }
    }

    private internalSaveAsync = async (action:() => Promise<boolean> = async () => true): Promise<boolean> => {
        if (!this.props.entity.RecordRight.CanWrite)
            return await action();
        else if (this.common.validate()) {
            let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/Save", { model: {...this.props.entity, Machines: [], WorkPackages: []}, lockId: this.props.entity.IsId });
            if (result.Code === 0) {
                if (this.props.entity.IsNew)
                    General.Functions.HistoryState.replaceState("RecurringTask/Edit?id=" + encodeURIComponent(result.Data.Id));
                let taskEntity = result.Data;
                this.updateEntity(taskEntity);
                return await action();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
                this.common.handlePostSave(false);
                return false;
            }

        }
    }

    private updateEntity(taskEntity: RecurringTaskEntity) {
        Helper.updateEntity(this.props.entity, taskEntity);
        this.reloadWorkPackages(this.props.entity.WorkPackages);

        this._refreshDeleteEnabled();
        if (Helper.hasValue(taskEntity.IsId) && this.lockId == undefined) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", taskEntity.IsId, "FST_RECURRING_TASKS", 10000);
        }
        this.common.handlePostSave(true);
    }

    // noinspection JSUnusedGlobalSymbols
    openRecurringTaskHistory = async () => {
        let results = await Promise.all([HTTPService.get<JsonResultClass<any>>('RecurrencePlan/Init?taskId=' + this.props.entity.Id), Helper.getMetaData("recurringTaskHistory")]);
        const entity = results[0].Data;
        entity.Task = this.props.entity;
        const metadata = results[1];
        const props: RecurringTaskHistoryProps = {
            context: {
                // lockControl: {
                //     needsLock: true,
                //     lockAcquired: false,
                //     lockValid: this.props.context.lockControl.lockValid,
                //     LockInfo: {...this.props.context.lockControl.LockInfo}
                // }
            },
            title: Helper.getTranslation("WebCRM.Tasks.RecurringTask.Executions"),
            entity: entity,
            metadata: metadata,
            dataSources: {},
            isWindow: false,
            onActionFailed: (_) => this.Init()
        }

        let open = () => {
            const sheet = General.Sheet.Manager.createSheet();
            sheet.show(() => {
                sheet.mountContent(RecurringTaskHistoryApp, props);
            });
            sheet.bind(SheetEventType.Custom, (data: { command: string, data: any }) => {
                switch (data.command) {
                    case "triggerNextExecution":
                        this.Init();
                        break;
                    case "cancelExecution":
                        this.Init();
                        break;
                    case "finishExecution":
                        this.Init();
                        break;
                }
            })
        };
        this.internalSave(open).then(() => {});
    }

    private Init = async () => {
        let result = await HTTPService.get("RecurringTask/Init?id=" + this.props.entity.Id);
        this.updateEntity(result.Data);
    }

    private openTask(task: RecurringTaskEntity) {

        const sheet = General.Sheet.Manager.createSheet();

        const props: RecurringTaskAppProps = {
            context: {
                key1: "entity.Id",
                keyVal1: "",
                contextType: "recurringTask",
                workPackageGridOptions: null,
                machineGridOptions: null,
                standAlone: false
            },
            title: "",
            entity: task,
            metadata: this.props.metadata,
            dataSources: {},
            isWindow: false
        };

        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.setState({});
        });
        sheet.show(() => {
            sheet.mountContent(RecurringTaskApp, props);
        }) ;
    }

    // noinspection JSUnusedGlobalSymbols - aufgerufen aus json
    copyTask = async () => {
        let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>('RecurringTask/CopyTask?Id=' + this.props.entity.Id);
        if (result.Code === 0) {
            this.openTask(result.Data);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }

    }

    // noinspection JSUnusedGlobalSymbols - aufgerufen aus json
    canOpenAddProject = () => {
        if (!this.props.entity.IsNew && this.common.unloadHelper.isEntitySaved()) {
            return true;
        } else {
            NotificationHelper.showWarningMessage(Config.translations.saveDataFirst);
            return false;
        }
    }

    private canActivate = () => {
        let isValid = true;
        if (this.props.entity.WorkPackages.length === 0) {
            return {canActivate: false, message: Helper.getTranslation("WebCRM.Tasks.RecurringTask.EnterWorkpackage")};
        } else {
            for (let i = 0; i < this.props.entity.WorkPackages.length; i++) {
                if (this.props.entity.WorkPackages[i].CapacityRequirements.length === 0) {
                    isValid = false;
                    break;
                }

            }
            if (!isValid)
                return {canActivate: false, message: Helper.getTranslation("WebCRM.Tasks.RecurringTask.RequiredCapacity")};
            if (!Helper.hasValue(this.props.entity.MergedProps.ProjectNo)) {
                return {canActivate: false, message: Helper.getTranslation("Field.fstasks.SaveCheckMsg.ProjectRequired")};
            }
        }
        if (isValid)
            return {canActivate: true, message: ""};
    }
    activate = () => {
        if (this.common.validate()) {
            const canActivate = this.canActivate();
            if (canActivate.canActivate) {
                this.internalSave(this.activateTask);
            } else {
                DialogHelper.confirm(canActivate.message, null, null, null, false);
            }
        }
    }

    // noinspection JSUnusedGlobalSymbols - aufgerufen aus json
    showTaskErrors = async () => {
        let taskId = this.props.entity.Id;
        let result = await Promise.all([HTTPService.get<JsonResultClass<TriggeringErrorListEntity>>('RecurringTask/Errors?taskId=' + taskId), Helper.getMetaData("taskErrors")]);

        const entity = result[0];

        if (entity.Code > 0) {
            NotificationHelper.showErrorMessage(entity.Message);
            return;
        }

        const sheet = General.Sheet.Manager.createSheet();

        const props: TriggeringErrorListAppProps = {
            context: {
                key1: "entity.Id",
                keyVal1: taskId,
                contextType: "taskErrors"
            },
            entity: entity.Data,
            metadata: result[1],
            dataSources: {},
            isWindow: false,
            doResetAll: async (): Promise<boolean> => { return await this.resetErrorsForTask() }
        };

        // sheet.bind(SheetEventType.SavedSuccessfully, () => {
            // this.reloadTreeData();
        // });
        // sheet.bind(SheetEventType.ItemDeleted, () => {
            // this.reloadTreeData();
        // });
        sheet.show(() => {
            sheet.mountContent(TriggeringErrorListApp, props);
        });
    }
    
    resetErrors = () => {
        this.internalSave(this.resetErrorsForTask);
    }

    finish = () => {
        this.dialogQuestion(Helper.getTranslation("WebCRM.Tasks.RecurringTask.ReallyComplete"), () => {
            this.internalSave(this.finishTask);
        });
    }
    
    private cancelPosition = (_: TaskPositionCancellingParam, individualFields: {}): Promise<boolean> => {
        return this.internalSaveAsync(async () => await this.cancelTask(individualFields));
    }

    cancel = () => {

        openCancellationView({
            PositionId: this.props.entity.Id,
            IsGroupNode: false,
            Level: 1, // hauptsache nicht 0 - bei IsGroupNode = false ist der Level eigentlich egal.
            PositionNo: this.props.entity.TaskNo,
            PositionTitle: this.props.entity.Title
        }, this.cancelPosition).then();
    }

    // noinspection JSUnusedGlobalSymbols - aufgerufen aus json
    changePeriod = () => {
        this.internalSave(this.changeTaskPeriod);
    }

    private dialogQuestion = async (question: string, action) => {
        const isOk = await DialogHelper.confirm(question);
        if (isOk)
            action();
    }

    private changeTaskPeriod = async () => {
        const sheet = General.Sheet.Manager.createSheet();
        let results = await Promise.all([HTTPService.get<JsonResultClass<ChangePeriodEntity>>("RecurringTask/InitChangePeriod?id=" + encodeURIComponent(this.props.entity.Id)), Helper.getMetaData("changeTaskPeriod")]);
        if (results[0].Code === 0) {
            sheet.show(() => {
                let title = Helper.getTranslation("WebCRM.Tasks.Title.ChangePeriod.Cycle").replace("{Title}", this.props.entity.Title);
                const changePeriodVm = results[0].Data;
                changePeriodVm.RecordRight = {CanRead: true, CanWrite: true};
                changePeriodVm.TriggeredCount = this.props.entity.TriggeredCount;
                const props: ChangeTaskPeriodAppProps = {
                    entity: changePeriodVm,
                    title: title,
                    metadata: results[1],
                    context: {contextType: "changeTaskPeriod"},
                };
                sheet.setTitle(title);
                sheet.mountContent(ChangeTaskPeriodApp, props);
            });
        } else {
            NotificationHelper.showErrorMessage(results[0].Message);
        }
        sheet.bind(SheetEventType.SavedSuccessfully, async (data: any) => {
            let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/ChangePeriod", { model: data.entity, lockId: this.props.entity.IsId });
            if (result.Code === 0) {
                this.updateEntity(result.Data);
                sheet.hide();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    private finishTask = async () => {
        let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/Finish", { id: this.props.entity.Id, lockId: this.props.entity.IsId });
        if (result.Code === 0) {
            this.updateEntity(result.Data);

            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.RecurringTask.SuccessFulCompleted"));
        } else{
            NotificationHelper.showErrorMessage(result.Message);
            this.common.handlePostSave(false);
        }
    }
    
    private resetErrorsForTask = async (): Promise<boolean> => {
        let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/ResetAllErrors", { id: this.props.entity.Id, lockId: this.props.entity.IsId });
        if (result.Code === 0) {
            this.updateEntity(result.Data);

            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.RecurringTask.SuccessFulCompleted"));
            return true;
        } else{
            NotificationHelper.showErrorMessage(result.Message);
            this.common.handlePostSave(false);
            return false;
        }
    }

    private cancelTask = async (individualFields: {}): Promise<boolean> => {
        let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/Cancel", { id: this.props.entity.Id, individualFields: individualFields, lockId: this.props.entity.IsId });
        if (result.Code === 0) {
            this.common.unloadHelper.removeBeforeUnloadCallback(this.releaseLock);
            this.releaseLock();
            this.updateEntity(result.Data);
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.RecurringTask.CancelledSuccesfully"));
            return true;
        } else {
            NotificationHelper.showErrorMessage(result.Message);
            this.common.handlePostSave(false);
            return false;
        }
    }

    // noinspection JSUnusedGlobalSymbols - aufgerufen aus json
    openExecuteAllTasks = async () => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(Helper.getTranslation("WebCRM.Tasks.ExecuteAll.ScheduleIntervalls"));
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.setState({}, () => {
                this.common.sheetWrapper.trigger(SheetEventType.Custom, {event: "Reloading"});
            });
        });
        sheet.show(() => {
            const props: ExecuteAllAppLauncherProps = {
                isWindow: true,
                entityPreallocation: (filter) => {
                    filter.TaskNo = this.props.entity.TaskNo;
                    return filter;
                }
            };

            sheet.mountContent(ExecuteAllAppLauncher, props);
        });
    }

    startReactivating = async () => {
        if(this.props.entity.MergedProps.State.Value != 3)
        {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.Reactivate.CancelledOnly"));
            return;
        }
        let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/Reactivating", {
            id: this.props.entity.Id
        });
        if(result.Code === 0) 
        {
            this.updateEntity(result.Data);
            if (this.props.entity.RecordRight.CanWrite) {
                if (!this.common.unloadHelper) 
                    this.common.createUnloadHelper();
                this.common.unloadHelper.addBeforeUnloadCallback(this.releaseLock);
            }
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.ActivateSucceeded"));            
        }else{
            NotificationHelper.showErrorMessage(result.Message);
            this.common.handlePostSave(false);
        }
    }
    
    private activateTask = async () => {
        let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/Activate", { id: this.props.entity.Id, lockId: this.props.entity.IsId });
        if (result.Code === 0) {
            this.updateEntity(result.Data);

            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.RecurringTask.ActivationSucceedes"));
        } else {
            NotificationHelper.showErrorMessage(result.Message);
            this.common.handlePostSave(false);
        }
    }

    private deleteMachines = async (id: string | string[]) => {
        
        const isOk = await DialogHelper.confirm(Config.translations.delete);
        if (isOk) {
            if(!(id instanceof Array)){
                id = [id]
            }
            for (let i=0; i< id.length; i++) {
                let item = this.props.entity.Machines.findIndex((elem) => elem.Machine.MaschNr === id[i]);
                if (item >= 0) {
                    this.internalSave(async () => {
                        let result = await HTTPService.post<JsonResultClass>("RecurringTask/DeleteMachine", { taskId: this.props.entity.Id, maschNr: id[i], lockId: this.props.entity.IsId });
                        if (result.Code === 0) {
                            let result = await HTTPService.get<JsonResultClass<RecurringTaskEntity>>("RecurringTask/Init?id=" + this.props.entity.Id);
                            this.updateEntity(result.Data);
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
                }
            }
        }
    }
    
    private editMachine = async (machine: any) => {
        let metaData = await Helper.getMetaData("taskMachine");

        const entityCopy = JSON.parse(JSON.stringify(machine));
        entityCopy.RecordRight.CanRead = true;
        entityCopy.RecordRight.CanWrite = this.props.entity.RecordRight.CanWrite;
        const editTaskMachineAppProps: EditTaskMachineAppProps = {
            disabled: false,
            entity: entityCopy,
            metadata: metaData,
            context: { key1: "entity.TaskMachineId", keyVal1: entityCopy.TaskMachineId, contextType: "taskMachine" },
            dataSources: {},
            isWindow: true,
            title: Helper.getTranslation("WebCRM.Tasks.Title.EditTaskMachine")
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.SavedSuccessfully,
            async (taskMachine: TaskMachine) => {
                if (!this.props.entity.RecordRight.CanWrite) return;
                    
                if (this.common.validate()) {
                    let updateTaskMachineRequest = {
                        taskId: this.props.entity.Id,
                        taskMachine: taskMachine,
                        lockId: this.props.entity.IsId
                    };
                    let result = await HTTPService.post<JsonResultClass<TaskMachine>>("RecurringTask/UpdateMachine", updateTaskMachineRequest);
                    if (result.Code === 0) {
                        let taskEntity: RecurringTaskEntity = {...this.props.entity, 
                            Machines: this.props.entity.Machines.map((tm) => tm.TaskMachineId == taskMachine.TaskMachineId ? result.Data : tm ) };
                        
                        this.updateEntity(taskEntity);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                        this.common.handlePostSave(false);
                    }
                }
            });

        sheet.show(() => {
            sheet.mountContent(EditTaskMachineApp, editTaskMachineAppProps);
        });
    }    
    
    private addMachine = (fieldProps: GridFieldProps) => {
        const adrNr = encodeURIComponent(this.props.entity.MergedProps.AddressNo);
        const cycleNo = encodeURIComponent(this.props.entity.TaskNo);
        let searchType = fieldProps?.field?.searchSettings?.searchType ?? "Machine";
        let displayPattern = fieldProps?.field?.searchSettings?.displayPattern || "[[maschnr]] [[maschbezeichnung]]";
        let fillAdrNr = fieldProps?.field?.searchSettings?.fillAdrNr ?? true;
        let disableAdrNr = fieldProps?.field?.searchSettings?.disableAdrNr ?? true;
        let forceAdrNrEqual = fieldProps?.field?.searchSettings?.forceAdrNrEqual ?? true;
        
        let url = `DynamicSearch/Window/${searchType}/?multi=true&displayPattern=${displayPattern}&cus_CycleNo=${cycleNo}`;
        if (fillAdrNr)
            url += `&adrnr=${adrNr}`;
        if (disableAdrNr)
            url += `&disabled=adrnr`;
        if (forceAdrNrEqual)
            url += `&cus_AdrNrEquals=${adrNr}`;
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, {disableTabTitle: true});
        const newMachines = new Array<string>();

        sheet.bind(SheetEventType.Close, () => {
            if (this.props.entity.TriggeredCount === 0)
                this.setState({}, () => {
                    this.updateMachineSelection(newMachines)
                });
        })
        sheet.bind(SheetEventType.ItemsSelected, (ev) => {
            if (ev.data.length > 0) {
                const data = ev.data;

                for (let i = 0; i < data.length; i++) {
                    let maschNr = data[i].maschnr;
                    let activeTaskMachineIndex = this.props.entity.Machines.findIndex((elem) => elem.Machine.MaschNr === maschNr && (elem.ExecutionNoTill == null || elem.ExecutionNoTill > this.props.entity.TriggeredCount)); 
                    if (activeTaskMachineIndex == -1) {
                        newMachines.push(maschNr);
                    }
                }
                if (newMachines.length > 0) {
                    this.internalSave(async () => {
                        let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/AddMachines", { taskId: this.props.entity.Id, machNos: newMachines, lockId: this.props.entity.IsId });
                        if (result.Code === 0) {
                            this.updateEntity(result.Data);
                            this.setState({}, () => {
                                this.updateMachineSelection(newMachines)
                            });
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
                }
            }
        });
    }

    handleClickStandardButton = (fieldProps: GridFieldProps, type: ToolBarStandardButtonType, dataItem: TaskMachine | TaskMachine[]) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this.addMachine(fieldProps);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            if (!(dataItem instanceof Array))
                dataItem = [dataItem];

            const machines = dataItem.map(m=> m.Machine.MaschNr);
            this.deleteMachines(machines).then(() => {});
        } else if (type == ToolBarStandardButtonType.EDIT)
        {
            this.editMachine(dataItem).then(() => {});
        }
    }

    private selectionMachineChange = (dataItem: TaskMachine | TaskMachine[]) => {
        if (Helper.hasValue(dataItem)) {
            let deleteEnabled: boolean;
            let applyTemplateEnabled: boolean;
            let enableMachineDeactivate: boolean;

            if (dataItem instanceof Array) {
                applyTemplateEnabled = dataItem.length > 0 && !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite;
                enableMachineDeactivate = dataItem.length > 0 && !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite &&
                    this.props.entity.ExplicitProps.State.Value == TaskState.Active && this.machinesActive(dataItem);
                deleteEnabled = dataItem.length > 0 && !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite &&
                    this.props.entity.ExplicitProps.State.Value == TaskState.Active && this.machinesNotTriggered(dataItem);
            } else {
                applyTemplateEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite &&
                    ((!Helper.hasValue(dataItem.ExecutionNoTill)) || (dataItem.ExecutionNoTill >= this.props.entity.TriggeredCount));
                enableMachineDeactivate = !this.props.entity.IsNew 
                    && this.props.entity.RecordRight.CanWrite 
                    && this.props.entity.ExplicitProps.State.Value == TaskState.Active 
                    && dataItem.ExecutionNoFrom <= this.props.entity.TriggeredCount 
                    && ((!Helper.hasValue(dataItem.ExecutionNoTill)) || (dataItem.ExecutionNoTill > this.props.entity.TriggeredCount));
                deleteEnabled = this.props.entity.RecordRight.CanWrite &&
                    (dataItem.ExecutionNoFrom > this.props.entity.TriggeredCount);
            }

            this.setState({ deleteMachineEnabled: deleteEnabled,  applyTemplateEnabled, enableMachineDeactivate });
        }
    }

    private machinesActive(machines: TaskMachine[]) {
        let output = true;
        machines.forEach(dataItem => 
            output = output 
                && dataItem.ExecutionNoFrom <= this.props.entity.TriggeredCount
                && (dataItem.ExecutionNoTill == null || dataItem.ExecutionNoTill > this.props.entity.TriggeredCount));
        return output;
    }
    
    private machinesNotTriggered(machines: TaskMachine[]) {
        let output = true;
        machines.forEach(dataItem => output = output && dataItem.ExecutionNoFrom > this.props.entity.TriggeredCount);
        return output;
    }

    private updateMachineSelection = (newMachines: string[]) => {
        const grid: Grid = this.mashinesGridRef;
        if (newMachines != null && newMachines.length > 0) {
            let uids: string[] = new Array<string>();

            let data = grid.getGridRef().dataSource.view();
            for (let i = 0; i < data.length; i++) {
                const mash = data[i].Machine.MaschNr;
                if (newMachines.indexOf(mash) > -1) {
                    uids.push(data[i].uid);
                }
            }

            if (uids.length == newMachines.length) {

                grid.getGridRef().clearSelection();
                for (let i = 0; i < uids.length; i++) {
                    let row = grid.getGridRef().tbody.find("tr[data-uid='" + uids[i] + "']");
                    grid.getGridRef().select(row);
                }
                grid.getGridRef().trigger("change");
            }
        }
    }

    private handleDataBound = (e) => {
        let data = e.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            if ((Helper.hasValue(data[i].ExecutionNoTill)) && (data[i].ExecutionNoTill <= this.props.entity.TriggeredCount)) {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("background-color", "#bdbdbd");
                cell.css("color", "#000000");
            }
        }
    }

    // noinspection JSUnusedGlobalSymbols - aufgerufen aus json
    renderMachineGrid = (fieldProps: GridFieldProps) => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({
            type: ToolBarStandardButtonType.NEW,
            caption: Config.translations.newLabel,
            enabled: this.props.entity.RecordRight.CanWrite
        });
        if (fieldProps?.field?.customButtonSettings?.editBtn ?? false)
            standardButtons.push({
                type: ToolBarStandardButtonType.EDIT,
                caption: Config.translations.editLabel,
                enabled: this.props.entity.RecordRight.CanWrite
            });
        standardButtons.push({
            type: ToolBarStandardButtonType.DELETE,
            caption: Config.translations.deleteLabel,
            enabled: this.state.deleteMachineEnabled
        });

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({
            autoEnabledOnRecordSelected: true,
            caption: Helper.getTranslation("WebCRM.Tasks.Task.Machine.Disable.ButtonTitle"),
            enabled: this.state.enableMachineDeactivate,
            iconClass: "k-i-cancel-circle",
            id: "enable_machine_deactivate"
        });
        if (fieldProps?.field?.customButtonSettings?.applyTemplateBtn ?? true)
            customButtons.push({
                autoEnabledOnRecordSelected: true,
                caption: Helper.getTranslation("WebCRM.Tasks.Task.Machine.ApplyTemplate.ButtonTitle"),
                enabled: this.state.applyTemplateEnabled,
                iconClass: "k-i-redo",
                id: "apply_wp_template"
            });  
        if (fieldProps?.field?.customButtonSettings?.addAllFromAddressBtn ?? true)
            customButtons.push({
                autoEnabledOnRecordSelected: false,
                caption: Helper.getTranslation("WebCRM.Tasks.Task.Machine.Add.AddFromAddress"), //Alle hinzufügen
                enabled: this.props.entity.RecordRight.CanWrite,
                iconClass: "k-i-plus-outline",
                id: "add_from_address"
            });
        if (fieldProps?.field?.customButtonSettings?.addAllFromProjectBtn ?? true)
            customButtons.push({
                autoEnabledOnRecordSelected: false,
                caption: Helper.getTranslation("WebCRM.Tasks.Task.Machine.Add.AddFromProject"), //Alle aus Projekt
                enabled: this.props.entity.RecordRight.CanWrite,
                iconClass: "k-i-plus-outline",
                id: "add_from_project"
            });
        
        const content =
            <div style={{ height: "400px" }}> 
                <Grid ref={(r) => this.mashinesGridRef = r}
                    data={this.props.entity.Machines} 
                    options={this.machineGridOptions} 
                    id="RecurringTaskMachineGrid"
                    standardButtons={standardButtons}
                    onDataBound={this.handleDataBound}
                    onClickStandardButton={this.handleClickStandardButton.bind(this,fieldProps)} 
                    customButtons={customButtons}
                    onClickCustomButton={this.handleCustomButtonClick}
                      copyCellValue={true}
                    onSelectionChanged={this.selectionMachineChange}/>
            </div>

        return (content);
    }

    private selectWorkpackageTemplateId = (): Promise<string> => {
        return new Promise<string>((resolve) => {
            const url = "DynamicSearch/Window/WorkPackageTemplates?fullObject=true";
            const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, {disableTabTitle: true});
            sheet.bind(SheetEventType.RowClicked, (ev) => {
                resolve(ev.id);
            });
            sheet.bind(SheetEventType.Close, () => {
                resolve(null);
            });
        })
    }

    private getActiveWorkpackage = (): WorkPackageEntity => {
        if (this.props.entity.WorkPackages.length === 0)
            return null;
        if (this.props.entity.RecurrenceSchema.Type === 'RecurrenceSchemaOnceViewModel') {
            return this.props.entity.WorkPackages.find((p) => p.Id === this.props.entity.RecurrenceSchema.WorkPackageId);
        }
        let index = this.props.entity.RecurrenceSchema.SchemaList.length - 1;
        if (index < 0)
            return null;
        return this.props.entity.WorkPackages.find((p) => p.Id === this.props.entity.RecurrenceSchema.SchemaList[index].WorkPackageId);
    }

    //Guid taskId, Guid templateId, Guid workPackageId, List<string> machines, int lockId
    private applyWorkPackageTemplate = (templateId, wp, taskMashines: string[]) => {
        this.internalSave(async () => {
            // alle taskMachines zum Server schicken und Arbeitspaket erweitern.
            let result = await HTTPService.post<JsonResultClass>("RecurringTask/ApplyWorkPackageTemplate",
                { taskId: this.props.entity.Id, templateId: templateId, workPackageId: wp, machines: taskMashines, lockId: this.props.entity.IsId });
            if (result.Code === 0) {
                // anschließend muss man die GUI neu laden.
                this.updateEntity(result.Data);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    handleCustomButtonClick = async (id: string, dataItem: TaskMachine | TaskMachine[]) => {
        if (id === "apply_wp_template") {
            let wp = this.getActiveWorkpackage();
            if (wp) {
                if (wp.IsTriggered) {
                    NotificationHelper.showErrorMessage(Helper.getTranslation("WebCRM.Tasks.Task.Machine.ApplyTemplate.WorkPackageTriggered"));
                    return;
                }

                if (!(dataItem instanceof Array))
                    dataItem = [dataItem];

                const machines = dataItem.map(m => m.Machine.MaschNr);

                // jetzt können wir die Suche nach Arbeitspaketvorlagen aufrufen...
                const workpackageTemplateId = await this.selectWorkpackageTemplateId();
                if (!Helper.isNullOrEmpty(workpackageTemplateId)) {
                    this.applyWorkPackageTemplate(workpackageTemplateId, wp.Id, machines);
                }
            } else {
                NotificationHelper.showErrorMessage(Helper.getTranslation("WebCRM.Tasks.Task.Machine.ApplyTemplate.NoWorkpackage"));
            }
        }
        if (id === "enable_machine_deactivate") {
            if (!(dataItem instanceof Array))
                dataItem = [dataItem];
            const machines = dataItem.map(m => m.Machine.MaschNr);
            this.deactivateMachine(machines);
        }
        if(id === "add_from_address"){
            this.addMachinesFromAddress();
        }
        if(id === "add_from_project"){
            this.addMachinesFromProject();
        }
    }

    private deactivateMachine(machines: string[]) {
        this.internalSave(async () => {
            let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/DisableMachine",
                { taskId: this.props.entity.Id, maschNrs: machines, lockId: this.props.entity.IsId });
            if (result.Code === 0) {
                this.updateEntity(result.Data);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }
    
    private addMachinesFromAddress(){
        this.internalSave(async ()=> {
            let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/AddMachinesFromAddress",
                { taskId: this.props.entity.Id, adrNr: this.props.entity.MergedProps.AddressNo, lockId: this.props.entity.IsId });
            if (result.Code === 0) {
                this.updateEntity(result.Data);
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        })
    }

    private addMachinesFromProject(){
        this.internalSave(async ()=> {
            let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/AddMachinesFromProject",
                { taskId: this.props.entity.Id, projNo: this.props.entity.MergedProps.ProjectNo, lockId: this.props.entity.IsId });
            if (result.Code === 0) {
                this.updateEntity(result.Data);
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        })
    }

    handleIsSearchFieldFullObjectModel = () => {
    }
    
    componentDidMount() {
        this.props.context.workPackageGridOptions = this.workPackageGridOptions;
        this.props.context.machineGridOptions = this.machineGridOptions;
        if (Helper.hasValue(this.props.entity.IsId) && this.lockId == undefined && this.props.entity.RecordRight.CanWrite) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.IsId, "FST_RECURRING_TASKS", 10000);
        }
    }

    private reloadWorkPackages = (packages :WorkPackageEntity[]) => {
        this.workPackagesDs = packages.map(p=>{
            return {
                Key:p.Id,
                Value:p.Title
            }
        })
        if (this.workPackagesDs.length === 1)
            MetaDataHelper.setFieldValue(this.props.entity, "entity.RecurrenceSchema.WorkPackageId", this.workPackagesDs[0].Key)
        this.common.commandManager.runCommand("WorkPackageId", Commands.RELOADDATASOURCE);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), {
            apphelper: this.common,
            handleFieldChange: this.handleFieldChange,
            handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel
        });
        this.props.dataSources.workPackagesDs = this.workPackagesDs;
        const titleProps: PageTitleProps = {
            title: this.props.title,
            locked: Helper.hasValue(this.props.entity.LockMessage) && this.props.entity.LockMessage.trim() !== "",
            lockInfo: this.props.entity.LockMessage
        };
        return (<CommonApp {...props} titleProps={titleProps}/>);
    }
}

export interface TaskProps {
    AddressNo: string;
    ProjectNo: string;
    State: EnumEntity<TaskState>;
    StartsOn: string;
    EndsOn: string;
    OGrNr: number;
    Knr: number;
    Kennung?: string;
}

export interface TaskMachine extends Entity {
    TaskMachineId: string;
    Machine: MachineEntity;
    ExecutionNoFrom?: number;
    ExecutionNoTill?: number;
    WorkPackageTemplateId?: string;
    WorkPackageTemplateTitle?: string;
}

export interface MachineEntity extends Entity {
    MaschNr: string;
    MaschBezeichnung: string;
    MaschNr2: string;
    MaschTyp: string;
    Adrname: string;
    Installtermin: Date;
    Adrnr: string;
}

export interface RecurringTaskEntity extends Entity {
    Id: string;
    TaskNo: string;
    Title: string;
    TriggerOnInit: boolean;
    ToleranceStart: string;
    ToleranceEnd: string;

    RecurrenceSchema: RecurenceSchemaEntity;
    WorkPackages: Array<WorkPackageEntity>;
    Machines: TaskMachine[];
    MergedProps: TaskProps;
    ParentProps: TaskProps;
    ExplicitProps: TaskProps;

    TriggeredCount: number;
    LastExecutionOn: string;

    ParentGroupId: string;
    NonFinishedExecution: number;

    IsId?: number;
    LockMessage: string;

    ExecutionMgmtEnabled: boolean;
    ReactivatingEnabled: boolean;
}

export interface RecurringTaskAppProps extends AppBaseProps {
    entity: RecurringTaskEntity;
    context: RecurringTaskAppContext;
}

export interface RecurringTaskAppContext extends Context {
    workPackageGridOptions?: {};
    machineGridOptions?: {};
    standAlone: boolean;
}

export enum TaskState {
    Draft,
    Active,
    Finished,
    Cancelled,
}

interface RecurringTaskAppState {
    deleteMachineEnabled: boolean;
    // editMachineEnabled: boolean;
    applyTemplateEnabled: boolean;
    enableMachineDeactivate: boolean;
}

interface GridFieldProps {
    field: {
        customButtonSettings: {
            applyTemplateBtn: boolean;
            addAllFromAddressBtn: boolean;
            addAllFromProjectBtn: boolean;
            editBtn?: boolean;
        };
        searchSettings: {
            searchType: string;
            displayPattern: string;
            fillAdrNr: boolean;
            disableAdrNr: boolean;
            forceAdrNrEqual: boolean;
        };
    };
    disabled: boolean;
}